/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Import_FileInputs */

const en_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the import file menu`)
};

const fr_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu d'import`)
};

const de_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie das Menü „Datei importieren“.`)
};

const it_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il menu di importazione del file`)
};

const ru_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте меню импорта файла.`)
};

const es_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra el menú de archivo de importación`)
};

const zh_cn2_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开导入文件菜单`)
};

const ja_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートファイルメニューを開く`)
};

const hi_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात फ़ाइल मेनू खोलें`)
};

const pt_pt2_shortcut_keys_desc_import_file = /** @type {(inputs: Shortcut_Keys_Desc_Import_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o menu de importação de arquivos`)
};

/**
* | output |
* | --- |
* | "Open the import file menu" |
*
* @param {Shortcut_Keys_Desc_Import_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_import_file = /** @type {((inputs?: Shortcut_Keys_Desc_Import_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Import_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_import_file(inputs)
	if (locale === "de") return de_shortcut_keys_desc_import_file(inputs)
	if (locale === "it") return it_shortcut_keys_desc_import_file(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_import_file(inputs)
	if (locale === "es") return es_shortcut_keys_desc_import_file(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_import_file(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_import_file(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_import_file(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_import_file(inputs)
	return en_shortcut_keys_desc_import_file(inputs)
});